let $sliders = $('.recommend-letters-js');

window.addEventListener('resize', initSliders);
initSliders();

function initSliders() {
  $sliders.each((key, slider) => {
    initSlider($(slider));
  });
}

function initSlider($slider) {
  if(window.innerWidth > 1200){
    $slider.trigger('destroy.owl.carousel');
  }else {
    $slider.owlCarousel({
      margin: 15,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        481: {
          items: 2,
        },
        700: {
          items: 3,
        },
        900: {
          items: 4,
        },
        1000: {
          items: 5,
        },
      },
    });
  }
}